import axios, { type AxiosInstance } from "axios"
import { baseURL, version } from "../env"

export const apiPrefix = "/api/v1"

export const apiBaseURL = `${baseURL}${apiPrefix}`

export const api: AxiosInstance = axios.create({
  baseURL: apiBaseURL,
  headers: { "X-Version": version },
  paramsSerializer: {
    serialize: (params) => {
      if (!params) return ""

      const keys = Object.keys(params)
      if (keys.length === 0) return ""

      const { where, sort, limit, offset } = params
      if (where) params.where = JSON.stringify(where)
      if (sort) params.sort = sort.join(",")
      if (limit) params.limit = String(limit)
      if (offset) params.offset = String(offset)

      return new URLSearchParams(Object.entries(params).filter((item) => !!item[1])).toString()
    },
  },
})
